// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> american-landmark-preferred -> the-griffin
// Generated: 2026-11-03T20:24:57.148Z
// Counts: 2 design, 82 content, 33 slot group, 5 collection binding, 8 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_icon"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "hyperlocal-links.show_header": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "hyperlocal-links.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "petpolicy.stat_pet_fee_sublabel": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "scheduleatour.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "scheduleatour.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_thankyou_blurb"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Griffin, everyone deserves an easy, welcoming experience—online and at home. We're committed to keeping our website accessible to all visitors and continually improving it so you can explore our community with confidence.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From two resort-style pools and sunning decks to a pair of fitness centers, a resident clubhouse, conference rooms, grilling areas, and a leash-free bark park, The Griffin keeps everyday life in Brandon relaxed and easy to enjoy. Inside, granite or quartz counters, premium appliances, wood-style flooring, smart home features, generous closets, and in-home laundry bring that same effortless comfort home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>You're just a few clicks from calling The Griffin home.</strong> Complete your online application to claim a spacious one-, two-, or three-bedroom home in Brandon—complete with resort-inspired pools, two fitness centers, and everyday-easy finishes—and start settling into modern living with room to spread out.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Ready to make The Griffin your Brandon home?</strong> Reach out to our leasing team with any questions about floor plans, availability, or amenities—we're happy to help you find the perfect fit. Whether you're touring for the first time or already a resident, we're just a message away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "favoriteplaces.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Brandon has quietly grown into one of Tampa Bay's most rewarding suburbs for food and fun, with local kitchens and lively hangouts tucked all along Lumsden Road and State Road 60. Explore our handpicked list of nearby favorites and find the spots that will make this corner of Hillsborough County feel like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Find the layout that fits your life.</strong> Browse one-, two-, and three-bedroom apartments and a spacious townhome-style home at The Griffin, ranging from 822 to 1,570 square feet. Each plan pairs elevated finishes and in-home laundry with select touches like screened patios, garages, and lake, pool, or wooded views.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>See yourself at The Griffin.</strong> Scroll through bright kitchens with granite counters, stainless appliances, and tile backsplashes, plus open living spaces, wood-style flooring, and spacious bedrooms with generous closets. Then explore the community side—resort-style pools and sundecks, two fitness centers, the resident clubhouse and lounges, grilling courtyards, a leash-free bark park, and serene lake, pool, and wooded views.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Brandon puts everyday essentials and standout nights out within easy reach of The Griffin, from Lumsden Road favorites like Tibby's New Orleans Kitchen and Bonefish Grill to shopping at Brandon Exchange and green space at Paul Sanders Park. With I-75 and the Selmon Expressway just minutes away, downtown Tampa, Ybor City, and the Gulf beaches all stay comfortably within reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Griffin, your four-legged family members are welcome to roam our leash-free bark park and stretch out in select homes with fenced yards. Discover how easy pet-friendly Brandon living can be.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Griffin, your privacy matters as much as your comfort. Learn how we collect, use, and safeguard the personal information of our residents and visitors.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "promopopup.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/01a044d4-2ab0-70f3-906f-d7723c6a8db7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Your resident portal puts everyday living at The Griffin at your fingertips—pay rent, submit and track maintenance requests, and stay in the loop on community updates anytime. Log in below to manage your account and get back to enjoying spacious Brandon living, resort-style pools, and relaxed community spaces.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Residents say The Griffin stands out for its people and its convenience.</strong> Reviews repeatedly praise a helpful leasing team, quick and professional maintenance, spacious upgraded apartments, renovated pools and amenities, and fun monthly events—all in a Brandon location that's walking distance to shopping and dining with easy access to I-75 and the Selmon Expressway. Read on to hear what residents appreciate most about calling The Griffin home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>There's no better way to feel the easygoing pace of The Griffin than to experience it in person. Book an in-person or virtual tour today and see how spacious Brandon living, resort-inspired amenities, and elevated finishes come together.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore everything The Griffin has to offer—browse floor plans, tour our amenities, and find your way to modern Brandon living with room to spread out.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Thank you—we’ve received your inquiry.</strong> The Griffin leasing team will be in touch soon, so keep picturing modern Brandon living with spacious one-, two-, and three-bedroom layouts, smart home features, and relaxed resort-inspired community spaces made for settling in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside The Griffin without leaving home—stroll our Brandon community and tour spacious apartment layouts on your own schedule. Take a self-guided look at the resort-inspired spaces and elevated finishes waiting for you.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.nav_col2_link2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/leadership"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/careers"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/news"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Contact us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.utility_link_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "scheduleatourcallout.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_self_guided_tour_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenitieshomesection.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and palm trees."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f7-6dc9-757b-ac73-5d1f28b08f38.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pools"
      }
    }
  },
  "amenitieshomesection.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with weightlifting equipment and cardio machines"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f7-4ebe-72db-a140-f8711b09b79d.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Two Fitness Centers"
      }
    }
  },
  "amenitieshomesection.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge with a coffee bar and seating area."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89f9-fefc-76bb-8c81-189a5f3f61cf.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Clubhouse"
      }
    }
  },
  "amenitieslist.featured": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Swimming pool with lounge chairs and apartment buildings in the background."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Two Resort-Style Pools"
      },
      "eyebrow": {
        "type": "VALUE",
        "customValue": "Featured Amenity"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-2163-748f-a9d5-7d925c097a9c.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "<p>The Griffin's two resort-style pools are the heart of the community, framed by swaying palms, lush landscaping, and plenty of lounge seating for soaking up the Florida sun. Whether you're cooling off after a workout or gathering friends for a laid-back weekend, the poolside sundecks make relaxing feel like a mini getaway just steps from home.</p>"
      }
    }
  },
  "amenitieslist.in_home_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f6-eb92-729f-aacb-a36d57b9986d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops."
      }
    }
  },
  "favoriteplaces.place_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-9d86-749f-bdf0-e7a104eb10f8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Tibby's New Orleans Kitchen"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Tibby's New Orleans Kitchen"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://tibbys.com/"
      }
    }
  },
  "favoriteplaces.place_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-622a-7287-acf3-7141a2347743.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bonefish Grill"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Bonefish Grill"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://locations.bonefishgrill.com/florida/brandon/1015-providence-road?y_source=1_MTU1MDI2NzUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D"
      }
    }
  },
  "favoriteplaces.place_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019f14e4-c637-72c9-8210-0bf150775ee8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "O’Brien’s Irish Pub & Grill"
      },
      "title": {
        "type": "VALUE",
        "customValue": "O’Brien’s Irish Pub & Grill"
      },
      "url": {
        "type": "VALUE",
        "customValue": "http://www.obrienspubsbrandon.com/"
      }
    }
  },
  "homefeaturessplit.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f7-d575-7619-89e6-ca9b0eb27a2e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and palm trees in front of an apartment building."
      }
    }
  },
  "homegallerygrid.gallery_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f7-029c-7367-8820-af4ac01dc91a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living and dining area with kitchen view."
      }
    }
  },
  "homegallerygrid.gallery_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-1ec4-70da-a529-f255d92e9e60.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish bedroom with a large bed, accent chairs, and a window with blinds."
      }
    }
  },
  "homegallerygrid.gallery_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f6-eb92-729f-aacb-a36d57b9986d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops."
      }
    }
  },
  "homeintrosection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019e89fa-436a-762f-b078-c6e377392b1a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a brown sofa, armchair, coffee table, and accent wall."
      }
    }
  },
  "neighborhoodctahomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f7-64ef-765a-a46f-f20991d13547.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Griffin multifamily property monument sign with landscaping and building in the background."
      }
    }
  },
  "neighborhoodhomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f7-33b2-7568-884d-30feb8150e80.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with a pathway and green lawn."
      }
    }
  },
  "pageblurb.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f6-1d9c-70cd-83d5-dabf9a16b7a1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Griffin apartment community entrance sign framed by palm trees and lush landscaping."
      }
    }
  },
  "pageblurb.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f7-6dc9-757b-ac73-5d1f28b08f38.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Griffin's resort-style swimming pool with lounge chairs and palm trees."
      }
    }
  },
  "pageblurb.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f7-5e3b-7439-9564-eb65300271be.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Griffin's elegant lobby with modern seating and a reception desk."
      }
    }
  },
  "residentaccess.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f6-1d9c-70cd-83d5-dabf9a16b7a1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Griffin apartment community entrance sign framed by palm trees and landscaping"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Make a Payment"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://thegriffinalm.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f6-b913-755d-bfe2-8bf54e8e5fb0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious apartment living room with a sectional sofa, coffee table, and decorative cabinet"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Portal"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://thegriffinalm.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449163357/019d02f6-4214-763e-b529-374b4c908524.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Griffin clubhouse and resort-style pool courtyard surrounded by palm trees"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Contact Us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_8ccaf925-e10e-4f5c-a6bd-fe2e914918c3",
      "custom_9cdeee86-995f-4e38-8b9e-fd20aecb6fc8",
      "custom_59457173-4c59-4bd4-acfa-60c2b64c3b7b",
      "custom_d6a5fbb9-1084-4be4-a77d-f8e470657045",
      "custom_e8df19ee-6783-42b0-b05f-20c639e4be80",
      "custom_038054d3-4cd8-4f3d-92f8-c96ec75686bd",
      "custom_ce2ba478-f68f-4acb-9a20-8e400e4dd5ec",
      "custom_f5ad73d8-29fd-4f6a-9285-d42106b5eaff",
      "custom_2e336706-113f-454e-94ff-ef5bf80a2f93",
      "custom_b31f98b1-f1dd-464f-a91e-06b1c7268462",
      "custom_64d7732f-f3a4-4045-8dec-9dd5d3ba4886",
      "custom_674f5ccc-fece-45c3-a916-eda3104aefe7",
      "custom_1b1abe1e-30ca-4a3c-be74-d56f8e9c2159",
      "custom_eee4a6c4-40e0-4ed6-8664-582a14180a40",
      "custom_82a54628-bd76-4369-82d2-b18c5714d8d1",
      "custom_ec4b4d89-2156-4bb3-9faf-9ad087791a2e",
      "custom_17feecfd-12fc-459a-b843-6075583bdbd1",
      "custom_64ab252a-fe26-40d4-a463-badebe3f077a",
      "custom_cd0beb51-7571-4674-89be-3c3c72fa1e11",
      "custom_8a688383-a61b-4ca4-94a6-25286fc33017",
      "custom_549ddea5-f3fc-4cc9-84e0-80a0d2f18727",
      "custom_e89837e9-f14a-44ec-b4bf-07e04ae27bc6",
      "custom_9b98dad6-ee66-4e38-b89d-35d838a19575",
      "custom_256da63a-ace5-461b-a6ae-3078f9db23c3",
      "custom_ea5064a3-d43c-407f-bb87-c840e7f2ed58",
      "custom_1222e6be-95fc-4d0f-af4e-51ce9af6920e",
      "custom_14bd5793-be21-43c2-a12d-9f428b88d877",
      "custom_557abb6e-a6b7-453a-be4b-17dadc3eeda5",
      "custom_22bc18eb-4c47-4fe2-b429-fe37a8198af5",
      "custom_dbc87fea-2ac5-441e-a3ba-896ca07a8284",
      "custom_c7de5a7b-4d52-4537-8674-3624ca4b57f8",
      "custom_3ed65079-ac9f-494c-892f-59a3c5609ae8",
      "custom_b3f40153-e860-40f4-be45-e6c72c89b82b",
      "custom_d37490cf-4ff9-41cf-aade-aa4278aff7e2"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "homegallerycarousel.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_c1641a42-3ff4-44c3-87f6-8a6b3ae35c52",
      "custom_8c4d1a30-efe0-4180-bb82-d82b4d0b19cb",
      "custom_f40522f3-2c9b-41eb-8733-14f1eaed5625",
      "custom_8d6f3e94-af82-4efc-ab33-4179119ed083"
    ],
    "orderedIds": [
      "custom_d3efeacb-969a-4fbb-bb39-6a6504956bbf",
      "custom_85542c0a-491d-4247-8b94-bc793c0c6ad5",
      "custom_1e3449dc-ec1a-4135-a64c-c46740788e9e",
      "custom_628a1f05-720e-428d-8ad3-7e0973f0cf0b",
      "custom_d0185f80-fa41-4e3a-82a9-46935bd53cc9",
      "custom_18163497-42be-4f2d-8590-2dbcdab8cc3f",
      "custom_fd32557f-1be2-489e-a9e8-adccecde37ef",
      "custom_7f7db8f7-02f9-49d1-b3fb-c3458cc64fff",
      "custom_e86d4072-a24f-483a-afad-b5cc36c90127",
      "custom_c11b0bf2-b793-4e26-9042-865c40db255c",
      "custom_bb90883c-6380-4e64-a7c5-5d978a4df1a5",
      "custom_62f0d2cb-ee23-4f45-93ac-5e20b26bd79c",
      "custom_8d6f3e94-af82-4efc-ab33-4179119ed083",
      "custom_f40522f3-2c9b-41eb-8733-14f1eaed5625",
      "custom_8c4d1a30-efe0-4180-bb82-d82b4d0b19cb",
      "custom_c1641a42-3ff4-44c3-87f6-8a6b3ae35c52",
      "custom_d40a45cd-dcb6-49d3-9c77-01b9779f01b4",
      "custom_2e6db05b-6dac-4259-b9d3-7cb5acff5bb5",
      "custom_70a24f71-1d65-4d04-813a-0165df2aa26f",
      "custom_c6a6ffc0-edb8-484b-a32e-d3063e5685ff",
      "custom_c7d69305-e366-4ecd-a1b1-f07de36e7aa5",
      "custom_2b4430a3-98a1-49b8-a86a-f990dbf584a0",
      "custom_82f9e5d7-6fc6-419b-9462-1bb84074fb13",
      "custom_388d0345-a0b8-4408-8516-87c603f8bf3f",
      "custom_3d2b06f3-3dc7-47f1-8a6a-b972404c045c",
      "custom_43cb9213-13e5-4360-ab03-1d0e6859d172",
      "custom_bc6d9937-06bb-4ee8-bc8e-005c496aa94b",
      "custom_2e650497-f0f8-4c29-a183-ff44b41180b5",
      "custom_1351da3d-267f-4479-bca8-c516f1e822d0",
      "custom_8375cb4b-5274-4eaf-9604-d7f0e7e4c937",
      "custom_c53d1926-9f84-4995-b264-7076056c2e36",
      "custom_268eab08-c7dd-436d-be10-e970b60e124c",
      "custom_7c4b7894-8ff3-4e88-91b6-cec6f7043d4d",
      "custom_b55e76c3-223f-48df-b5ed-b29b92789d97"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "leasing-ai-pixel",
      "blockId": "leasing-ai-pixel",
      "position": 0
    }
  ],
  "home": [
    {
      "sectionId": "hyperlocal-links",
      "blockId": "hyperlocal-links",
      "position": 17
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "neighborhoodmap.category_order": {
    "properties": {
      "textAlign": "center"
    }
  }
};
